import { roles } from "../constants";
import { user } from "../user";

export const canEditNews = () => user.hasRoles(...roles.admin(), roles.DataEntry);
